import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Order, OrdersService } from '@compumark/order-management-client';
import { Observable, shareReplay } from 'rxjs';

@Component({
  selector: 'app-add-watch-order-dialog',
  templateUrl: './add-watch-order-dialog.component.html',
  styleUrls: ['./add-watch-order-dialog.component.scss'],
  standalone: false,
})
export class AddWatchOrderDialogComponent implements OnInit {
  private data = inject(MAT_DIALOG_DATA);
  private orderService = inject(OrdersService);
  dialogRef = inject<MatDialogRef<AddWatchOrderDialogComponent>>(MatDialogRef);

  public orders$: Observable<Order[]>;

  constructor() {
    this.orders$ = new Observable<Order[]>();
  }

  ngOnInit(): void {
    this.orders$ = this.loadActiveOrders();
  }

  private loadActiveOrders(): Observable<Order[]> {
    return this.orderService.getOrders('active').pipe(shareReplay(1));
  }

  onAddWatchOrders(): void {
    this.dialogRef.close({ updatedData: this.data });
  }
}
